export const GET_WXINFO = 'GET_WXINFO'
export const RECORD_WXINFO = 'RECORD_WXINFO'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js